import { sum } from "../../../../services/array-helpers";
import { formatCurrency, formatDate } from "../../../../services/format";

import { GetGasRentalBillingList, PreAuthorizeCreditCard, SendReport, UpdateBilling, deleteInvoice, downloadReport, getBillingHeader, reverseBilling } from "../../../../services/requests/billing/gas-rental-billing-requests";

import { FormItemType } from "../../../UI/view/component-map";
import { DataSource } from "../../../UI/view/data-source";
import { FormView } from "../../../UI/view/form-view";
import { ListViewColumnType } from "../../../UI/view/list-view";
import { initView } from "../../../UI/view/view";
import { billingPermissions } from "../billing-datasource";
import { gasRentalReportLink, footerItems } from "../billing-invoice-edit";

export const gasrentalinvoicesDS = {
  request: GetGasRentalBillingList,
  pk: 'billingId',
  name: 'gasrentalinvoice',
  updateRequest: UpdateBilling,
  entityRequest: getBillingHeader,
  /*   serverSideEvents: true */
} as DataSource;

export const gasRentalsEdit = {
  editMode: true,
  pageHeader: 'Gas Rentals Billing',
  permissions: billingPermissions,
  breadcrumbs: [
    {
      name: 'Gas Rentals Billing',
      icon: 'currency-dollar',
      to: '/billing/gas#Invoices',
    },
  ],
  items: [
    {
      type: FormItemType.masterDetailLayout,
      items: [
        {
          items: [
            {
              type: FormItemType.infoPane,
              header: ({ gasrentalbill }) => gasrentalbill?.current?.data?.customerName,
              infoListItems: [

                {
                  label: 'Customer',
                  name: 'customerName'
                },
                {
                  label: 'Customer ID',
                  name: 'customerId'
                },
                {
                  label: 'Invoice Number',
                  name: 'billingId'
                },
                {
                  label: 'JDE Batch Number',
                  name: 'jdebatchNumber'
                },
                {
                  label: 'Date Invoiced',
                  name: 'dateInvoiced',
                  value: ({ dateInvoiced }) => formatDate(dateInvoiced)
                },
                {
                  label: 'Billing Period',
                  name: 'billingPeriod',
                  value: ({ invoiceMonth, invoiceYear }) => `${invoiceMonth}/${invoiceYear}`
                },
                {
                  label: 'Free Rent Days Per Trip',
                  name: 'freeDays'
                },

                {
                  label: '$/Day',
                  name: 'pricePerDay',
                  value: ({ pricePerDay }) => formatCurrency(pricePerDay)
                },

                {
                  label: 'Total',
                  value: (a, watch) => {
                    const vals = watch('gasRentalBillingDetails');
                    if (!vals) return '';
                    return formatCurrency(sum(vals.map((v) => v.value)));
                  }
                },


              ]
            },
            {
              type: FormItemType.fileAttachments,
              entityTypeId: 13,
              entityName: 'Billing Invoice',
            },
          ]
        },
        {
          type: FormItemType.tab,
          items: [
            {
              label: 'Gas Rentals',
              footerItems: footerItems('Gas_Rental_Billing_Summary', gasRentalReportLink, PreAuthorizeCreditCard, deleteInvoice, downloadReport, reverseBilling, SendReport).filter(x => x.label != 'PreAuthorize Credit Card'),
              items: [
                {
                  type: FormItemType.fieldset,
                  label: 'Rental Billing',
                  items: [
                    {
                      type: FormItemType.row,
                      items: [
                        {
                          name: 'ponumber',
                          label: 'PO Number',
                          minWidth: 200,
                          fitToContent: true,
                          defaultValue: ''
                        },
                      ]
                    },
                    {
                      label: '$/Day',
                      name: 'pricePerDay',
                      disabled: () => true
                    },
                    {
                      name: 'invoiceComments',
                      label: 'Invoice Notes',
                      type: FormItemType.textarea,
                      defaultValue: ''
                    },
                    {
                      name: 'gasCustomer.billingComments',
                      label: 'Customer Billing Comments',
                      type: FormItemType.textarea,
                      disabled: () => true,
                      defaultValue: ''
                    },
                    {
                      label: 'Bypass Invoice',
                      name: 'jdebypassed',
                      type: FormItemType.checkboxField,
                      width: 140,
                      fitToContent: true,
                      hideIf: ({ watch }) => watch('jdebatchNumber')
                    },
                  ]
                }
              ],
            },
            {
              label: 'Invoice Contents',
              footerItems: footerItems('Gas_Rental_Billing_Summary', gasRentalReportLink, PreAuthorizeCreditCard, deleteInvoice, downloadReport, reverseBilling, SendReport).filter(x => x.label != 'PreAuthorize Credit Card'),
              items: [
                {
                  type: FormItemType.fieldset,
                  label: 'Invoice Contents',
                  footerItems: [
                    {
                      type: FormItemType.submitButton,
                      label: 'Update Invoice',
                      variant: 'secondary',
                    }
                  ],
                  items: [
                    {
                      type: FormItemType.editTable,
                      name: 'gasRentalBillingDetails',
                      variant: 'tabular',
                      pk: 'id',
                      toolbar: [
                        {
                          type: FormItemType.checkboxField,
                          inline: true,
                          label: 'PO on Each Item',
                          name: 'Postyle',
                          width: 130,
                          fitToContent: true,
                        }
                      ],
                      columns: [
                        {
                          type: ListViewColumnType.delete,
                          id: 'deleteme'
                        },
                        {
                          accessor: 'ponumber',
                          Header: 'PO Number',
                          formItemProps: {
                            disabled: ({ watch }) => !watch('Postyle'),
                            name: 'ponumber',
                            defaultValue: '',
                            maxLength: 50,
                          }
                        },
                        {
                          Header: 'Gas S/N',
                          accessor: 'containerId',
                          formItemProps: {
                            name: 'containerId',

                            className: 'readonly'
                          }
                        },
                        {
                          Header: 'Port Arrival Date',
                          accessor: 'startDate',
                          formItemProps: {
                            name: 'startDate',

                            type: FormItemType.date,
                            className: 'readonly'
                          }
                        },
                        {
                          Header: 'Port Release Date',
                          accessor: 'endDate',
                          formItemProps: {
                            name: 'endDate',

                            type: FormItemType.date,
                            className: 'readonly'
                          }
                        },
                        {
                          Header: 'Days Billable',
                          accessor: 'daysBilled',
                          formItemProps: {
                            name: 'daysBilled',
                            onChange: (v, getValues, setValue, editTableProps) => {
                              const { rowIdentity } = editTableProps;
                              const { gasRentalBillingDetails, pricePerDay } = getValues();
                              const rowEntity = gasRentalBillingDetails[rowIdentity];

                              const daysBilled = Number(v ?? 0);
                              const rentalFeePerDayNum = Number(pricePerDay ?? 0);
                              setValue(`gasRentalBillingDetails[${rowIdentity}].value`, (daysBilled ?? 0) * (rentalFeePerDayNum ?? 0))
                            },
                            className: 'readonly'
                          }
                        },
                        /*                   {
                                            Header: '$/Day',
                                            accessor: 'rentalFeePerDay',
                                            formItemProps: {
                                              name: 'rentalFeePerDay',
                                              disabled: () => true,
                                              className: 'readonly'
                                            }
                                          }, */
                        {
                          Header: 'Total',
                          accessor: 'value',
                          formItemProps: {
                            name: 'value',

                            className: 'readonly'
                          }
                        },
                      ]

                    },
                  ]
                }

              ]
            }
          ]
        }
      ]
    }
  ]
} as FormView;


export const GasRentalEditInvoice = initView({ form: gasRentalsEdit, dataSource: gasrentalinvoicesDS })


